import src from "IMAGE";
export default { src, width: 200, height: 44, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMUlEQVR42i3FsQkAIAxFwb+WCIqCVioIVpL958grUhwnSYaHjYsTLzQoY6Dgo2KiIzmYggST6rw71wAAAABJRU5ErkJggg=="};
